import { IdLabel } from "../../../../components/IdLabel/index.js";
import { getTHERMSImageSmallUrl } from "../../../Files/utils/get-therms-image-small-url.js";
import { recordIcons } from "../record-icons.js";
import { getDefaultRecordImageUrl } from "../../utils/getDefaultRecordImageUrl.js";
import { useMemo, useState } from "react";
import { Button, Icon, Loading } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { MdClose } from "react-icons/md";
//#region src/modules/Records/shared/RecordsHorizontalScroll/RecordListItemHorizontal.tsx
function RecordListItemHorizontal({ description, idLabel, name, onClick, onRemove, primaryImageUrl, type }) {
	const [isRemoving, setIsRemoving] = useState(false);
	const imageUrl = useMemo(() => primaryImageUrl || getDefaultRecordImageUrl(type), [primaryImageUrl, type]);
	return /* @__PURE__ */ jsxs("div", {
		className: classnames({ "hover:bg-surface-strong active:bg-surface-subtle cursor-pointer transition": !!onClick }, "bg-surface group relative rounded"),
		onClick: !isRemoving ? onClick : void 0,
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "relative",
				children: [
					/* @__PURE__ */ jsx("img", {
						className: "h-36 w-full rounded-t object-cover",
						src: getTHERMSImageSmallUrl(imageUrl),
						alt: ""
					}),
					!!primaryImageUrl && /* @__PURE__ */ jsx("div", {
						className: "bg-surface px-xxs group-hover:bg-surface-strong group-active:bg-surface-subtle right-xs absolute bottom-0 rounded-t transition",
						children: /* @__PURE__ */ jsx(Icon, {
							Icon: recordIcons[type],
							size: "sm"
						})
					}),
					/* @__PURE__ */ jsx(IdLabel, {
						className: "bg-surface px-xxs text-color-subtle group-hover:bg-surface-strong group-active:bg-surface-subtle left-xs absolute bottom-0 rounded-t text-xs font-black tracking-wide transition",
						idLabel
					}),
					!!onRemove && /* @__PURE__ */ jsx("div", {
						className: "right-xs absolute top-0",
						children: /* @__PURE__ */ jsx("div", {
							className: "bg-surface group-hover:bg-surface-strong group-active:bg-surface-subtle rounded-b transition",
							children: /* @__PURE__ */ jsx(Button, {
								disabled: isRemoving,
								onClick: async (e) => {
									e.stopPropagation();
									setIsRemoving(true);
									try {
										await onRemove();
									} finally {
										setIsRemoving(false);
									}
								},
								subtle: true,
								size: "sm",
								children: /* @__PURE__ */ jsx(Icon, {
									Icon: MdClose,
									size: "xs"
								})
							})
						})
					})
				]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "p-xs",
				children: [/* @__PURE__ */ jsx("div", {
					className: "text-md line-clamp-2 font-medium",
					children: name
				}), /* @__PURE__ */ jsx("div", {
					className: "text-color-subtle line-clamp-2 text-xs",
					children: description
				})]
			}),
			isRemoving && /* @__PURE__ */ jsx(Loading, { overlay: true })
		]
	});
}
//#endregion
export { RecordListItemHorizontal };

//# sourceMappingURL=RecordListItemHorizontal.js.map